import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";
export var ICON_NAMES = [
    "accessibility",
    "add-user",
    "clear",
    "dark-color-mode",
    "light-color-mode",
    "auto-color-mode",
    "feedback",
    "reset",
    "evaluate",
    "menu",
    "nav-smart-back",
    "nav-back",
    "nav-next",
    "revert",
    "slide-link",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "chevron-up",
    "community-hide",
    "community-unhide",
    "activity-center",
    "checkmark-thin",
    "checkmark",
    "checkmark-bold",
    "confirm",
    "check-circle-fill",
    "check-circle-bold",
    "download",
    "eye-open",
    "eye-close",
    "eye-slash",
    "download-document",
    "page-current",
    "pages-all",
    "add",
    "save",
    "save-alt",
    "bonus-material",
    "filter",
    "settings",
    "globe",
    "home",
    "social-breadcrumb-home",
    "image",
    "circle-info",
    "circle-question",
    "circle-warning",
    "answer-wrong",
    "answer-correct",
    "answer-missed",
    "search",
    "chapters",
    "attachment",
    "notes",
    "notepad",
    "edit",
    "edit-alt",
    "print",
    "plus-line",
    "plus-circle",
    "plus-fill",
    "minus-line",
    "minus-circle",
    "minus-fill",
    "close-line",
    "close-circle",
    "close-fill",
    "share",
    "star-outline",
    "star-fill",
    "editor-bold",
    "editor-italic",
    "editor-underline",
    "delete",
    "user-outline",
    "user-fill",
    "user-admin",
    "community",
    "community-edit",
    "community-info",
    "lock-locked",
    "lock-unlocked",
    "close-menu",
    "close-socialmenu",
    "quick-navigation",
    "book-close",
    "book-open",
    "book-open-doutone",
    "media-play-hero",
    "media-play",
    "media-pause",
    "media-cc",
    "media-settings",
    "media-volume",
    "media-mute",
    "media-fullscreen",
    "media-fullscreen-exit",
    "text-linespacing-0",
    "text-linespacing-1",
    "text-linespacing-2",
    "text-linespacing-3",
    "text-wordspacing-0",
    "text-wordspacing-1",
    "text-wordspacing-2",
    "text-wordspacing-3",
    "text-letterspacing-0",
    "text-letterspacing-1",
    "text-letterspacing-2",
    "text-letterspacing-3"
];
function Icon(props) {
    var wrapperClasses = classNames("cbi", "cbi-".concat(props.name), "cbi-".concat(props.size), props.className);
    return /*#__PURE__*/ React.createElement("i", {
        className: wrapperClasses
    }, /*#__PURE__*/ React.createElement("svg", {
        className: "cbi__svg",
        width: "100%",
        height: "100%",
        role: "presentation",
        viewBox: "0 0 256 256",
        preserveAspectRatio: "xMidYMid meet"
    }, /*#__PURE__*/ React.createElement("use", {
        href: props.iconURL + "#cbi-" + props.name
    })));
}
var mapStateToProps = function(state, ownProps) {
    var _state_cbook;
    return {
        iconURL: ownProps.iconURL || (state === null || state === void 0 ? void 0 : (_state_cbook = state.cbook) === null || _state_cbook === void 0 ? void 0 : _state_cbook.icon_url)
    };
};
export default connect(mapStateToProps)(Icon);
